import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '../ellipsis-text/ellipsis-text';
import { Attachment } from '../bulletin-board.types';

@customElement('attachments-block')
export class AttachmentsBlock extends LitElement {
  @property({ type: Array })
  attachments: Array<Attachment> = [];

  static override styles = [
    css`
      :host {
        --bs-link-color-rgb: 0, 147, 208;
        --bs-link-opacity: 1;

        display: flex;
        flex-direction: column;
        max-width: 200px;

        font-size: 14px;
        font-weight: 400;
        line-height: 1rem;
      }

      ellipsis-text {
        max-width: 100%;
      }

      a {
        color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
      }
    `,
  ];

  override render() {
    if (this.attachments?.length > 0) {
      return html`
        ${this.attachments.map((attachment) => {
          if (attachment.id) {
            return html`
              <a
                href="#download-by-id-${attachment.id}"
                @click=${(e: Event) => this.linkClicked(e, attachment)}
              >
                ${this.filenameHTML(attachment)}
              </a>
            `;
          } else {
            return html`${this.filenameHTML(attachment)}`;
          }
        })}
      `;
    } else {
      return null;
    }
  }

  private filenameHTML(attachment: Attachment) {
    return html`<ellipsis-text>${attachment.filename}</ellipsis-text>`;
  }

  // Actions
  linkClicked(e: Event, attachment: Attachment) {
    e.preventDefault();

    const newEvent = new CustomEvent('download', {
      bubbles: true,
      composed: true,
      detail: attachment,
    });

    this.dispatchEvent(newEvent);
  }
}

export type DownloadEvent = CustomEvent<Attachment>;
